import type { QuizScenariosTranslations } from './quizScenarios.translation.pl.ts';

export const quizScenariosTranslations: QuizScenariosTranslations = {
  intro: {
    segment1: {
      title:
        "Pff… Encore la même chose. La réinitialisation n'a pas aidé. Qu'est-ce qui ne va pas avec cette cyber-boussole ?",
      content: {
        1: "Oh, salut ! Je suis content de te voir ! Je suis Orin. Je viens d'arriver chez Orange, et la première mission qu'on m'a confiée, c'est de calibrer ma boussole des valeurs, sauf qu'elle… m'a renvoyé dans le passé pour je ne sais quelle raison, et je me suis retrouvé ici. Mais... c'est peut-être parce que c'est toi qui dois m'aider ?",
        2: "Oh, attends une minute… Je vois que tu veux rejoindre les stages Let’s Orange ! Génial ! On peut s'entraider. Je vais calibrer trois valeurs : le courage, l'attention et la responsabilité, et au passage, tu découvriras si tes valeurs sont proches de celles qui comptent chez Orange.",
        3: "Alors ? On commence ? Allez, joue à ta façon ! Un portail s'ouvre - c'est parti pour un voyage dans le temps !",
      },
    },
    segment2: {
      title:
        "Bienvenue dans le futur ! Oui, tu vois bien. Nous sommes sur la Lune, qui est désormais un lieu important sur la carte spatiale d'Orange.",
      content:
        "C'est ici que l'on perfectionne la connexion 14G pour de nombreuses expéditions. Notre satellite s'y prête parfaitement. Les conditions de travail ne sont pas faciles, c'est pourquoi les tâches les plus difficiles sont confiées à des robots qui travaillent aux côtés des humains. Pas mal, hein ?",
    },
  },
  errors: {
    videoNotSupported: 'Ton navigateur ne prend pas en charge la vidéo.',
    errorBrowser: 'Erreur réseau ou problème de connexion.',
  },
  buttons: {
    next: 'Suivant',
  },
};
